import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';

// scroll bar
import 'simplebar/src/simplebar.css';

// highlight
import './utils/highlight';

// slick-carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';

// @mui
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import './theme/global.css';

import './locales/i18n';

import App from './App';
import { ReduxProvider } from './contexts/ReduxContext';
import { ErrorMonitorProvider } from './ErrorMonitorContext';
import client from './ApolloClient';

// ----------------------------------------------------------------------

ReactDOM.render(
  <ApolloProvider client={client}>
    <ErrorMonitorProvider>
      <ReduxProvider>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </LocalizationProvider>
      </ReduxProvider>
    </ErrorMonitorProvider>
  </ApolloProvider>,
  document.getElementById('root')
);
